export default __webpack_public_path__ + "static/media/Logo Ritail.app.3bc0195c.svg";